export enum rbacActions {

    ViewDashboard = 'ViewDashboard',

    ListAccounts = 'ListAccounts',
    GetAccount = 'GetAccount',
    CreateAccount = 'CreateAccount',
    UpdateAccount = 'UpdateAccount',
    DeleteAccount = 'DeleteAccount',
    // FNP-575: re-assign a Customer's owning account (re-points ownerAccountId,
    // the FNP-121 deletion-cascade key) — gated separately from UpdateAccount.
    ReassignCustomerOwner = 'ReassignCustomerOwner',

    ListApplications = 'ListApplications',
    GetApplication = 'GetApplication',
    CreateApplication = 'CreateApplication',
    UpdateApplication = 'UpdateApplication',
    DeleteApplication = 'DeleteApplication',
    // FNP-1007: mark an application DECOMMISSIONED when its infrastructure is
    // verifiably already gone. Gated on its own id rather than folded into
    // DeleteApplication because the blast radius is the opposite: this destroys
    // NOTHING and only corrects a record, while it does move that record to a
    // terminal state under a renamed identity. Admin-only, matching the
    // server's @aws_cognito_user_pools(cognito_groups: ["admin"]).
    MarkApplicationDecommissioned = 'MarkApplicationDecommissioned',

    ListOrganizations = 'ListOrganizations',
    GetOrganization = 'GetOrganization',
    CreateOrganization = 'CreateOrganization',
    UpdateOrganization = 'UpdateOrganization',
    DeleteOrganization = 'DeleteOrganization',

    ListOrganizationAccounts = 'ListOrganizationAccounts',
    GetOrganizationAccount = 'GetOrganizationAccount',
    CreateOrganizationAccount = 'CreateOrganizationAccount',
    UpdateOrganizationAccount = 'UpdateOrganizationAccount',
    DeleteOrganizationAccount = 'DeleteOrganizationAccount',
    DeactivateOrganizationAccount = 'DeactivateOrganizationAccount',

    ListAccountApplications = 'ListAccountApplications',
    GetAccountApplication = 'GetAccountApplication',
    CreateAccountApplication = 'CreateAccountApplication',
    UpdateAccountApplication = 'UpdateAccountApplication',
    DeleteAccountApplication = 'DeleteAccountApplication',

    ListApplicationAccounts = 'ListApplicationAccounts',
    GetApplicationAccount = 'GetApplicationAccount',
    CreateApplicationAccount = 'CreateApplicationAccount',
    UpdateApplicationAccount = 'UpdateApplicationAccount',
    DeleteApplicationAccount = 'DeleteApplicationAccount',

    ListApplicationProducts = 'ListApplicationProducts',
    GetApplicationProduct = 'GetApplicationProduct',
    CreateApplicationProduct = 'CreateApplicationProduct',
    UpdateApplicationProduct = 'UpdateApplicationProduct',
    DeleteApplicationProduct = 'DeleteApplicationProduct',

    ListUsers = 'ListUsers',
    GetUser = 'GetUser',
    CreateUser = 'CreateUser',
    UpdateUser = 'UpdateUser',
    DeleteUser = 'DeleteUser',

    GetSupport = 'GetSupport',
    GetPlatformHealth = 'GetPlatformHealth',

    GetWorkflow = 'GetWorkflow',
    CreateWorkflow = 'CreateWorkflow',
    UpdateWorkflow = 'UpdateWorkflow',
    DeleteWorkflow = 'DeleteWorkflow',

    ListPlaybooks = 'ListPlaybooks',
    GetPlaybook = 'GetPlaybook',
    CreatePlaybook = 'CreatePlaybook',
    UpdatePlaybook = 'UpdatePlaybook',
    DeletePlaybook = 'DeletePlaybook',

    ListPhases = 'ListPhases',
    GetPhase = 'GetPhase',
    CreatePhase = 'CreatePhase',
    UpdatePhase = 'UpdatePhase',
    DeletePhase = 'DeletePhase',

    ListSteps = 'ListSteps',
    GetStep = 'GetStep',
    CreateStep = 'CreateStep',
    UpdateStep = 'UpdateStep',
    DeleteStep = 'DeleteStep',

    ListWorkflowGroups = 'ListWorkflowGroups',
    GetWorkflowGroup = 'GetWorkflowGroup',
    CreateWorkflowGroup = 'CreateWorkflowGroup',
    UpdateWorkflowGroup = 'UpdateWorkflowGroup',
    DeleteWorkflowGroup = 'DeleteWorkflowGroup',

    ListActionGroups = 'ListActionGroups',
    GetActionGroup = 'GetActionGroup',
    CreateActionGroup = 'CreateActionGroup',
    UpdateActionGroup = 'UpdateActionGroup',
    DeleteActionGroup = 'DeleteActionGroup',

    ListActions = 'ListActions',
    GetAction = 'GetAction',
    CreateAction = 'CreateAction',
    UpdateAction = 'UpdateAction',
    DeleteAction = 'DeleteAction',

    ListPlaybookActionGroups = 'ListPlaybookActionGroups',
    GetPlaybookActionGroup = 'GetPlaybookActionGroup',
    CreatePlaybookActionGroup = 'CreatePlaybookActionGroup',
    UpdatePlaybookActionGroup = 'UpdatePlaybookActionGroup',
    DeletePlaybookActionGroup = 'DeletePlaybookActionGroup',

    ListApplicationScreenshots = 'ListApplicationScreenshots',
    GetApplicationScreenshot = 'GetApplicationScreenshot',
    CreateApplicationScreenshot = 'CreateApplicationScreenshot',
    UpdateApplicationScreenshot = 'UpdateApplicationScreenshot',
    DeleteApplicationScreenshot = 'DeleteApplicationScreenshot',
    // FNP-1353: Retake re-runs the capture and overwrites the stored image, so it
    // needs its own action rather than riding on UpdateApplicationScreenshot —
    // editing a screenshot's settings and re-shooting it are different privileges.
    RetakeApplicationScreenshot = 'RetakeApplicationScreenshot',

    ListExecutions = 'ListExecutions',
    ViewExecution = 'ViewExecution',
    ExecutePlaybook = 'ExecutePlaybook',
    CancelExecution = 'CancelExecution',

    // FNP-891 / FNP-893: platform-wide operational controls (the registration
    // kill-switch and its siblings). Viewing is separated from operating on
    // purpose — the list is deliberately broad so the controls stay visible to
    // anyone who might need to reason about them, while actually moving one is
    // a platform-wide action and is gated on its own id.
    ListPlatformControls = 'ListPlatformControls',
    OperatePlatformControl = 'OperatePlatformControl',

}


export const actions = Object.values(rbacActions);

export const actionConstants = actions.reduce((acc, action) => {
    acc[action.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? '_' : '') + match.toLowerCase())
              .toUpperCase()] = action;
    return acc;
}, {} as Record<string, string>);